module.exports = __webpack_public_path__ + "static/media/fhbf_fachberatungsstelle_logo.3d7991e5.png";